export const PRODUCT_PRICE_CONST = {
  ProductQuantityOne: 14,
  ProductQuantityTwo: 40,
  ProductQuantityThree: 99,
}
